@if (countries) {
<section class="product-availability-container">
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureProductDetails-productAvailability">Verfügbarkeit</h2>
        <div class="product-availability-description" i18n="@@featureProductDetails-productAvailability-description">
          Länderverfügbarkeit für dieses Produkt
        </div>
        <button class="expandable-button mat-body-2" (click)="openCountryAvailabilityModal()">
          <ng-container i18n="@@featureProductDetails-productAvailability-more">
            + Alle anzeigen ({{ countries.length }})
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</section>
}
